import { render } from "./TasksOverviewChart.vue?vue&type=template&id=3aa89321"
import script from "./TasksOverviewChart.vue?vue&type=script&lang=js"
export * from "./TasksOverviewChart.vue?vue&type=script&lang=js"

import "./TasksOverviewChart.vue?vue&type=style&index=0&id=3aa89321&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__